import { createContext, useContext } from 'react';

const IsNetlifyCMSContext = createContext(false);

export const useIsNetlifyCMSContext = () => useContext(IsNetlifyCMSContext);

export default IsNetlifyCMSContext;
